export enum EVWriteBackStatus {
  IN_PROGRESS = "In Progress",
  SUCCESS = "Success",
  ERROR = "Error",
  NOT_INITIATED = "not_initiated",
  QUEUED = "Queued",
}

export enum DocWriteBackStatus {
  IN_PROGRESS = "In Progress",
  SUCCESS = "Success",
  ERROR = "Error",
  NOT_INITIATED = "not_initiated",
  QUEUED = "Queued",
}

export enum NarRpsStatus {
  IN_PROGRESS = "In Progress",
  SUCCESS = "Success",
  ERROR = "Error",
  NOT_INITIATED = "not_initiated",
  QUEUED = "Queued",
}
